<template>
  <div class="container">
    <div class="row _margin-top-40">
      <div class="col-md-offset-3 col-md-6">
        <div class="card text-center" v-if="!error && loader">
          <h6>Redirecting. Please wait...</h6>
          <hr />
          <loader show />

          <p>
            We are searching for your information and will redirect you to your result as soon as we can.
            Please do not refresh your page.
          </p>
        </div>

        <div class="card" v-if="error && !loader">
          <h6>Redirect Failed</h6>
          <hr />
          <h4>Oops!</h4>
          <p>It looks like your link has failed. Let's try that again.</p>

          <uiv-btn type="button" @click="onTryAgain">
            Try Again
          </uiv-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProcessSwitchHold',
  data() {
    return {
      error: false,
      loader: true
    }
  },
  async mounted() {
    this.loader = true;
    await this.$store.dispatch('token/getToken');
    const error = await this.$store.dispatch('quote_results/processSwitchHold', this.$route.params);
    this.error = error;
    this.loader = false;

    if (!error) {
      this.$router.push({ name: 'quoteResults' });
    }
  },
  methods: {
    async onTryAgain() {
      this.$store.dispatch('tracing/addAction', { name: 'Page', value: 'Process Switch Hold' });
      this.$store.dispatch('tracing/addAction', { name: 'Action', value: 'Try Again' });
      await this.$store.dispatch('tracing/saveActions');
      this.$router.go(0);
    }
  }
};
</script>

<style lang="scss"></style>
